import { createSelector } from '@ngrx/store';

import {
  DecedentInfoState,
  getDecedentFirstName,
  getVerifyDecedentPayload,
} from '../../reducers/decedent-info/decedent-info.reducer';
import * as fromFeature from '../../reducers/index';
import {
  selectClientDateOfBirth,
  selectLast4IdOnFile,
} from '../personal-data/personal-data.selectors';
import { joinWithSpace } from '../receipt/cashier-nonretirement';

export const selectDecedentInfoState = createSelector(
  fromFeature.getDecedentInfoState,
  (state) => state,
);
export const selectDecedentFirstName = createSelector(
  fromFeature.getDecedentInfoState,
  getDecedentFirstName,
);
export const selectDecedentFullName = createSelector(fromFeature.getDecedentInfoState, (state) =>
  joinWithSpace([state.firstName, state.middleName, state.lastName]),
);
export const selectVerifyDecedentPayload = createSelector(
  fromFeature.getDecedentInfoState,
  getVerifyDecedentPayload,
);
export const selectIsDeathVerified = createSelector(
  fromFeature.getDecedentInfoState,
  (state) => state.isDeathVerified,
);
export const selectIsReviewModalVisible = createSelector(
  fromFeature.getDecedentInfoState,
  (state) => state.isReviewModalVisible,
);
export const selectDecedentIdExceededAttempts = createSelector(
  fromFeature.getDecedentInfoState,
  (state) => state.decedentIdExceededAttempts,
);

export const selectBeneMatch = createSelector(
  selectDecedentInfoState,
  selectLast4IdOnFile,
  selectClientDateOfBirth,
  (decedentState: DecedentInfoState, last4OnFile: string, clientDataOfBirth: string) => {
    if (
      decedentState &&
      decedentState.decedentId_private &&
      decedentState.dateOfBirth &&
      last4OnFile &&
      clientDataOfBirth
    ) {
      return (
        decedentState.decedentId_private.substring(7) === last4OnFile &&
        decedentState.dateOfBirth === clientDataOfBirth
      );
    }
    return false;
  },
);
